import React from 'react';
import PortalLayout from './PortalLayout';
import AdventuresContent from '../../components/AdventuresContent';
import { useAuth } from '../../context/AuthContext';

/**
 * Portal Adventures page (iter 79) - `/portal/adventures`.
 *
 * Same shared content as the public page, wrapped in the portal shell.
 * Visible to ALL tiers including free trial (never paywalled). Click
 * tracking uses surface="adventures_portal" with the viewer's role for
 * conversion analysis.
 */
const PortalAdventures = () => {
  const { user } = useAuth();
  return (
    <PortalLayout activeTab="adventures">
      <AdventuresContent surface="adventures_portal" userRole={user?.role || null} />
    </PortalLayout>
  );
};

export default PortalAdventures;
